<template>
  <div
    class="relative laptop:col-span-2 largeDesktop:col-span-1 bg-[#fff] tablet:max-w-[400px] tablet:mx-auto largeDesktop:max-w-[500px] pt-[20px]"
    :class="{ '!p-[30px] largeDesktop:!p-[50px] rounded-[20px] shadow-[0px_0px_20px_0px_#00000026]': mode != 'modal' }">
    <h2 v-if="mode != 'modal'"
      class="mb-[5px] text-[24px] largeDesktop:text-[40px] font-semibold font-poppins text-[#000]">Verification
    </h2>
    <p class="text-[14px] largeDesktop:text-[14.5px] font-normal font-poppins text-[#666]">Please enter the 4-digit
      verification code that has been sent to your registered mobile number <span class="font-semibold">
        {{ maskPhone(savedData.phone) }}</span>.</p>
    <div class="my-[50px]" :class="{ '!my-[60px] largeDesktop:!my-[100px]': mode != 'modal' }">
      <div class="mb-[40px] desktop:mb-[20px] largeDesktop:mb-[70px]">
        <div class="flex justify-center gap-[30px] mb-[20px] largeDesktop:mb-[40px]">
          <input v-for="(digit, index) in code" :key="index" v-model="code[index]" ref="inputs" @input="onInput(index)"
            @keydown.backspace="onBackspace(index)" @focus="handleFocus" maxlength="1" type="text" inputmode="numeric"
            class="w-[45px] h-[45px] text-center text-lg border rounded-[5px] focus:outline-none bg-[#2459A8] text-[#fff]" />
        </div>

        <button :disabled="!isCodeComplete" @click="submitCode" :class="[
          '!w-max mb-0 mx-auto table py-[8px] largeDesktop:py-[10px] px-[40px] largeDesktop:px-[60px] text-[16px] largeDesktop:text-[18px] font-medium font-poppins rounded-full border-solid border-[1px]',
          isCodeComplete
            ? 'CustomYellowBtn focus:outline-none'
            : 'border-[#EFEFEF] bg-[#EFEFEF] !text-[#999999] cursor-not-allowed '
        ]">
          VERIFY
        </button>
      </div>
      <div>
        <div class="text-base largeDesktop:text-lg font-normal text-[#666666]">
          <p v-if="timer" class="font-poppins text-center">
            Didn’t receive the code? You’ll be able to resend it in
            <span>{{ timer === 0 ? '' : '(' + timer + ' seconds)' }}</span>
          </p>
        </div>
        <div class="flex item-center justify-center gap-3 mt-[30px]">
          <button
            class="h-[35px] w-[110px] largeDesktop:h-[43px] largeDesktop:w-[125px] flex justify-center items-center font-roboto font-normal text-base largeDesktop:text-lg rounded-[5px] border-[1px] CustomYellowBtn focus:outline-none"
            @click="backClicked">
            Back
          </button>
          <button @click="resendCodeClicked" :disabled="timer > 0"
            class="h-[35px] w-[110px] largeDesktop:h-[43px] largeDesktop:w-[125px] flex justify-center items-center font-roboto font-normal text-base largeDesktop:text-lg rounded-[5px] border-[1px] CustomBlueBtn
            disabled:border-[#EFEFEF] disabled:bg-gradient-[unset] disabled:hover:bg-none disabled:bg-[#EFEFEF] disabled:hover:!bg-[#EFEFEF] disabled:text-[#999999] disabled:cursor-not-allowed focus:outline-none ">Re-send</button>
        </div>
      </div>
    </div>
    <!-- Copyright -->
    <copyright />
    <div class="col-span-2 mt-[5px]">
      <termsAndPrivacyComponent />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";
import copyright from "../../views/nest_views/copyright.vue";
const toast = useToast();
import termsAndPrivacyComponent from "./termsAndPrivacyComponent.vue";
export default {
  props: ["callbacks", "mode"],
  components: {
    copyright,
    termsAndPrivacyComponent
  },
  data() {
    return {
      code: ["", "", "", ""],
      timer: 30,
      interval: null,
      savedData: JSON.parse(localStorage.getItem('registerFormData')) ?? null
    };
  },

  computed: {
    ...mapGetters(["requestOtpResponse", "userObject", "userVerifyResponse", "consumerCartUpdateResponse"]),
    isCodeComplete() {
      return this.code.every((digit) => digit !== "");
    },
  },

  watch: {
    requestOtpResponse: function () {
      this.timer = 30;
      this.startTimer();
      if (this.requestOtpResponse != null) {
        if (this.requestOtpResponse.status == true) {
          toast.success(this.requestOtpResponse.message)
        } else {
          toast.error(this.requestOtpResponse.message)
        }
      }
    },

    userVerifyResponse: function () {
      let user = JSON.parse(localStorage.getItem('user')) ?? {}
      user['_token'] = this.userVerifyResponse._token
      localStorage.setItem('user', JSON.stringify(user))
      this.getProfile({
        is_show: true
      })
    },

    consumerCartUpdateResponse: function () {
      if (this.callbacks) {
        this.callbacks("verified")
      }
    },

    userObject: function () {
      if (this.userObject != 'undefined') {
        localStorage.removeItem('registerFormData')
        localStorage.setItem('user', JSON.stringify(this.userObject))
        this.consumerCartUpdate({})
      }
    },
  },

  mounted() {
    this.$refs.inputs[0].focus();
    this.startTimer();
  },
  methods: {
    ...mapActions(["requestOtp", "verifyUser", "getProfile", "consumerCartUpdate"]),

    maskPhone(number) {
      // keep only digits
      const digits = number.replace(/\D/g, '');

      // get last 4 digits
      const last4 = digits.slice(-4);

      // mask remaining digits
      const masked = 'X'.repeat(digits.length - 4);

      return masked + last4;
    },

    contractorAgreementClicked() {
      this.$router.push({
        name: 'termsAndConditions',
      });
    },

    privacyPolicyClicked() {
      this.$router.push({
        name: 'privacyPolicy',
      });
    },

    onInput(index) {
      // Remove non-numeric characters
      this.code[index] = this.code[index].replace(/\D/g, '');

      // Ensure only one digit
      if (this.code[index].length > 1) {
        this.code[index] = this.code[index].slice(0, 1);
      }

      // Move to next input
      if (this.code[index] && index < this.code.length - 1) {
        this.$refs.inputs[index + 1].focus();
      }
    },
    onBackspace(index) {
      if (!this.code[index] && index > 0) {
        this.$refs.inputs[index - 1].focus();
      }
    },
    handleFocus(event) {
      // scroll to element
      if (window.innerWidth < 1024) {
        setTimeout(() => {
          event.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
    },
    submitCode() {
      if (this.savedData && this.savedData.phone) {
        this.verifyUser({
          phone: this.$helper.extractPhoneNumber(this.savedData.phone),
          code: this.code.join(""),
          device_type: 'web'
        })
      } else {
        toast.error("You are not allowed to perform this action.")
        if (this.callbacks) {
          this.callbacks("back")
        }
      }
    },
    resendCodeClicked() {
      if (this.savedData && this.savedData.phone) {
        this.code = ["", "", "", ""];

        // Focus first input
        this.$nextTick(() => {
          if (this.$refs.inputs && this.$refs.inputs.length) {
            this.$refs.inputs[0].focus();
          }
        });
        this.requestOtp({
          phone: this.savedData.phone.includes("+") ? this.savedData.phone : this.$helper.extractPhoneNumber(this.savedData.phone),
        })
      } else {
        toast.error("You are not allowed to perform this action.")
        if (this.callbacks) {
          this.callbacks("back")
        }
      }

    },

    backClicked() {
      if (this.callbacks) {
        this.callbacks("back")
      }
    },
    startTimer() {
      if (this.interval) clearInterval(this.interval);
      this.interval = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        } else {
          clearInterval(this.interval);
        }
      }, 1000);
    },
  },
  unmounted() {
    if (this.interval) clearInterval(this.interval);
  },
};
</script>

<style scoped>
input::-webkit-inner-spin-button,
input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>